// Derives the display state of a route stop from the four route-progress
// timestamps the server returns under stop.state.
//
// Per MOBILE_LOCATION_SERVER_SPEC.md — the server stores timestamps, not a
// derived status column. Mapping:
//
//   finished_at set                         → 'completed'
//   started_at set, finished_at null        → 'in_progress'
//   arrived_at set, started_at null         → 'arrived'
//   started_travel_at set, arrived_at null  → 'in_travel'
//   all four null                           → 'up_next'

export const STOP_DISPLAY_STATES = Object.freeze({
  UP_NEXT:     'up_next',
  IN_TRAVEL:   'in_travel',
  ARRIVED:     'arrived',
  IN_PROGRESS: 'in_progress',
  COMPLETED:   'completed',
});

export const deriveStopDisplayState = (state) => {
  if (!state) return STOP_DISPLAY_STATES.UP_NEXT;
  if (state.finished_at) return STOP_DISPLAY_STATES.COMPLETED;
  if (state.started_at) return STOP_DISPLAY_STATES.IN_PROGRESS;
  if (state.arrived_at) return STOP_DISPLAY_STATES.ARRIVED;
  if (state.started_travel_at) return STOP_DISPLAY_STATES.IN_TRAVEL;
  return STOP_DISPLAY_STATES.UP_NEXT;
};

// Visual config — one source of truth for color + icon per display state.
// Consumed by StopMarker, ServiceCard's mobile variant, and the list-mode
// status pill. FA Pro Kit Sharp regulars per the project's icon convention.
export const STOP_STATE_VISUAL = Object.freeze({
  up_next:     { label: 'UP NEXT',     color: '#6c757d', icon: 'fa-sharp fa-regular fa-hourglass-half' },
  in_travel:   { label: 'EN ROUTE',    color: '#3B82F6', icon: 'fa-sharp fa-regular fa-car' },
  arrived:     { label: 'ARRIVED',     color: '#6366F1', icon: 'fa-sharp fa-regular fa-location-dot' },
  in_progress: { label: 'IN PROGRESS', color: '#F59E0B', icon: 'fa-sharp fa-regular fa-gears' },
  completed:   { label: 'COMPLETED',   color: '#10B981', icon: 'fa-sharp fa-regular fa-check' },
});

export default deriveStopDisplayState;
